var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M9.5 13.5C11.9825 13.5 14 11.4825 14 9C14 6.5175 11.9825 4.5 9.5 4.5C7.0175 4.5 5 6.5175 5 9C5 11.4825 7.0175 13.5 9.5 13.5Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15C12.815 15 15.5 12.315 15.5 9C15.5 5.685 12.815 3 9.5 3C6.185 3 3.5 5.685 3.5 9C3.5 12.315 6.185 15 9.5 15ZM9.5 4.5C11.9825 4.5 14 6.5175 14 9C14 11.4825 11.9825 13.5 9.5 13.5C7.0175 13.5 5 11.4825 5 9C5 6.5175 7.0175 4.5 9.5 4.5Z",
    fill: "#EA4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHold);
export default __webpack_public_path__ + "static/media/hold.0bba42e707ea0b072610ebceebf78c70.svg";
export { ForwardRef as ReactComponent };